import { render, staticRenderFns } from "./commonly.vue?vue&type=template&id=3bf15d6e&"
import script from "./commonly.vue?vue&type=script&lang=js&"
export * from "./commonly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports